import React from 'react';
import { Helmet } from 'react-helmet';
import './legal.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>Privacy Policy — dmyor</title>
        <link rel="canonical" href="https://www.dmyor.com/privacy-policy" />
        <meta name="description" content="Learn how dmyor collects and uses your data." />
        <meta property="og:title" content="Privacy Policy — dmyor" />
        <meta property="og:description" content="Learn how dmyor collects and uses your data." />
        <meta property="og:image" content="https://dmyor.com/images/og-image.png" />
        <meta property="og:url" content="https://www.dmyor.com/privacy-policy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="legal-header">
        <div className="legal-eyebrow">dmyor</div>
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: 09 December 2023</p>
      </div>

      <div className="legal-body">
        <p>
          This Privacy Policy explains how dmyor collects, uses, and protects your
          personal information when you use the platform. By using dmyor, you agree
          to the practices described here.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          When you register, we collect your name, email address, and optionally
          your date of birth and country. This is used to provide and personalise
          your experience on the platform.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>
          We use your information to operate your account, personalise your experience,
          and communicate with you about the platform. We do not sell or share your
          personal data with third parties for marketing purposes.
        </p>

        <h2>3. Information Usage</h2>
        <p>
          We treat your personal information with care. We do not share it with third
          parties, and we do not use it for behavioural analysis or advertising.
        </p>

        <h2>4. Security</h2>
        <p>
          We implement reasonable security measures to protect your data. That said,
          no method of transmission over the internet is completely secure, and we
          cannot guarantee absolute security.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain your information for as long as your account is active. If you
          choose to delete your account, your personal information will be removed
          from our systems.
        </p>

        <h2>6. Your Rights</h2>
        <ul>
          <li>Access the personal information we hold about you via your account.</li>
          <li>Update your information at any time from the Account section.</li>
          <li>Delete your account and all associated data at any time.</li>
        </ul>

        <h2>7. Changes to This Policy</h2>
        <p>
          This Privacy Policy may be updated periodically. We will notify you of
          significant changes via email or by posting a notice on the website.
        </p>

        <h2>8. Contact</h2>
        <p>
          For privacy-related questions or requests, contact us at{' '}
          <a href="mailto:support@dmyor.com">support@dmyor.com</a>.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
